import { useDecision } from '@optimizely/react-sdk';

import { DISABLE_DECISION, FLAG } from 'Utilities/analytics/optimizely/constants';

export type UseUnifiedSellerAcceptanceAboveReserveExperimentProps = {
  dpEnquiryId?: number;
  isEligible?: boolean;
};

export const useUnifiedSellerAcceptanceAboveReserveExperiment = ({
  dpEnquiryId,
  isEligible = false,
}: UseUnifiedSellerAcceptanceAboveReserveExperimentProps) => {
  const isEligibleForExperiment = Boolean(dpEnquiryId && isEligible);

  const [{ variationKey }, clientReady] = useDecision(
    FLAG.UNIFIED_SELLER_ACCEPTANCE_ABOVE_RESERVE,
    { decideOptions: isEligibleForExperiment ? [] : DISABLE_DECISION },
    { overrideUserId: dpEnquiryId?.toString() },
  );

  return isEligibleForExperiment && clientReady && variationKey === 'on';
};
